import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';

export interface DialogData {
  erro: HttpErrorResponse;
  mensagem: string;
  titulo: string;
}

@Component({
  selector: 'info-dialog',
  templateUrl: 'info-dialog.component.html',
  styleUrls: ['info-dialog.component.css'],
})
export class InfoDialogComponent {

  constructor(
    private location: Location,
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {

  }

  ngOnInit() {

    let innerWidth = window.innerWidth;

    this.data.titulo = this.data.titulo

     if (innerWidth < 1024) {
            this.dialogRef.updateSize('80%');
        }
        else {
            this.dialogRef.updateSize('30%');
        }

    if (this.data.erro != null) {

      if (this.data.erro.status == 401) {

        this.data.mensagem = "Sessão Expirada. Acesse novamente o sistema";

        this.location.go("login");
      }
      else {

        this.data.mensagem = "Erro ao processar requisição";

        if (this.data.erro.error != null) {
          if (this.data.erro.error.message != null) {
            this.data.mensagem = this.data.erro.error.message;
          } else {

            if (this.data.erro.error.errors != null) {
              const mensagens = Object.values(this.data.erro.error.errors).join('\n');
              this.data.mensagem = mensagens.replace(/\[(.*)\]/g, '$1').replace(/"/g, '');
            }
            else {
              this.data.mensagem = this.data.erro.error;
            }
          }

          if (this.data.erro.error.ExceptionMessage != undefined && this.data.erro.error.ExceptionMessage != null) {
            this.data.mensagem = this.data.erro.error.ExceptionMessage;
          }

        }
        else {

          if (this.data.erro.message != undefined) {

            this.data.mensagem = this.data.erro.message;
          }
        }
      }
    }
  }

  onOkClick(): void {
    this.dialogRef.close();
  }
}
